export const FETCH_ALL_PACK = 'fetch_all_pack';
export const FETCH_ALL_PACK_SUCCESS = 'fetch_all_pack_success';
export const EDIT_PACK = 'edit_pack';
export const DELETE_PACK = 'delete_pack';
export const CREATE_PACK = 'create_pack';
export const CREATE_PACK_SUCCESS = 'create_pack_success';
export const UPDATE_PACK_SUCCESS = 'update_pack_success';
export const UPDATE_PACK = 'update_pack';
export const DELETE_PACK_SUCCESS = 'delete_pack_success';
export const SET_PACK = 'set_pack';
export const SET_ROLE = 'set_role';